import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { DatePickerIcon, DatePickerNext, DatePickerPreview } from "themes/Icon";
import "./date_picker_comp.scss";

function DatePickerComp({
  className,
  suffixIcon,
  onChange,
  format = "DD-MM-YYYY",
  allowClear = true,
  defaultValue,
  placeholder = "Select date",
  disabledDate,
  disabled = false,
  value,
  setValue,
}) {
  const [date, setDate] = useState(
    defaultValue ? dayjs(defaultValue, format) : null
  );

  useEffect(() => {
    if (value) {
      setDate(dayjs(value, format));
    } else if (value === null) {
      setDate(null);
    }
  }, [value]);

  const handleDateChange = (date, dateString) => {
    setDate(date);
    if (onChange) {
      onChange(dateString);
    }
    if (setValue) {
      setValue(date);
    }
  };

  return (
    <DatePicker
      value={date}
      suffixIcon={suffixIcon || <DatePickerIcon />}
      placeholder={placeholder}
      className={`date-picker ${className}`}
      format={format}
      allowClear={allowClear}
      onChange={handleDateChange}
      nextIcon={<DatePickerNext />}
      prevIcon={<DatePickerPreview />}
      popupClassName="date-picker-popup"
      showNow={false}
      disabled={disabled}
      disabledDate={disabledDate}
    />
  );
}

export default DatePickerComp;
